import styled from 'styled-components';
import theme from 'src/theme';

export const GeneralSectionInputElementWrapper = styled.div`
    span.target-deviation-warning {
        color: ${theme.legacyColors.errorText};
    }
    .target-deviation-details {
        top: 20px;
        position: absolute;
        z-index: 100000;
        background-color: #f3f3d9;
        border: 1px solid #78785e;
        color: black;
    }
    .target-deviation-details-hidden {
        display: none;
    }
    .target-deviation-details-expanded {
        display: block;
        padding: 10px;
    }
    .target-deviation-detail {
        display: flex;
    }
    .target-deviation-details-button-wrapper {
        position: relative;
        left: 135px;
        top: -22px;
        border: 0;
    }
    .target-deviation-details-button {
        display: contents;
        height: 20px;
        width: 20px;
    }
    .input-and-icon {
        position: relative;
        height: 20px;
    }
    .mrv-data-warning {
        display: block;
        border: 1px solid #ccc;
        color: ${theme.legacyColors.errorText};
        font-weight: bolder;
    }
`;
